import * as Cookies from "js-cookie";

export const FIFTEEN_MINUTES_IN_MILLISECONDS = 1000 * 60 * 15;
export const MIDWAY_ID_TOKEN = "midwayIdToken";
export const MIDWAY_AUTH_USERNAME = "midwayAuthUsername";
export const UNKNOWN_USER = "UNKNOWN_SWO_UI_USER"

export const getUserAlias = (): string => {
    return Cookies.get(MIDWAY_AUTH_USERNAME) || UNKNOWN_USER;
}